type GradeId =
  | string
  | number
  | {
      value?: string | number;
    }
  | null
  | undefined;

type ResolveGuestGradeIdParams = {
  guestIndex: string | number;
  guestPosition: number;
  gradeId?: GradeId;
  guestsUsedInDynamicForm?: Record<string, string | number> | null;
  guestsCache?: Guest[] | null;
  guestsGradeIds?: GradeId[] | GradeId | null;
};

type Guest = {
  Id?: string | number;
  GradeId?: GradeId;
  grade?: GradeId;
};

export function resolveGuestGradeId({
  guestIndex,
  guestPosition,
  gradeId,
  guestsUsedInDynamicForm,
  guestsCache,
  guestsGradeIds,
}: ResolveGuestGradeIdParams): string {
  const normalizedGradeId = normalizeGradeId(gradeId);

  if (normalizedGradeId) {
    return normalizedGradeId;
  }

  const selectedGuestId = guestsUsedInDynamicForm?.[`${guestIndex}`];
  const selectedGuest = guestsCache?.find(
    (guest) => guest?.Id === selectedGuestId
  );
  const selectedGuestGradeId = normalizeGradeId(
    selectedGuest?.GradeId || selectedGuest?.grade
  );

  if (selectedGuestGradeId) {
    return selectedGuestGradeId;
  }

  return normalizeGradeId(
    getGuestGradeIdByPosition(guestsGradeIds, guestPosition)
  );
}

export function normalizeGradeId(gradeId: GradeId): string {
  const resolvedGradeId =
    typeof gradeId === "object" && gradeId !== null ? gradeId.value : gradeId;

  if (resolvedGradeId === undefined || resolvedGradeId === null) {
    return "";
  }

  return `${resolvedGradeId}`.trim();
}

function getGuestGradeIdByPosition(
  guestsGradeIds: GradeId[] | GradeId | null | undefined,
  guestPosition: number
): GradeId {
  if (!guestsGradeIds) {
    return;
  }

  const gradeIds = Array.isArray(guestsGradeIds)
    ? guestsGradeIds
    : [guestsGradeIds];

  return gradeIds[guestPosition];
}
